import { useSelector } from 'react-redux';
import { RootState } from '~/store';
import { MARKETS_WITH_MIGRATED_CARD_TERMS_KEYS } from '~/constants/markets';
import useOpenLink from './useOpenLink';

const useCardLinks = () => {
  const openExternalLink = useOpenLink();
  const {
    intl: { market },
  } = useSelector((state: RootState) => state);

  const openProductTerms = () => {
    openExternalLink('LinkUrls.CardTerms', 'MissingCardGeneralTermsUrl');
  };

  const openPriceList = () => {
    openExternalLink('LinkUrls.CardPriceList', 'MissingCardPriceListUrl');
  };

  const openGeneralTerms = () => {
    openExternalLink('LinkUrls.GeneralTerms', 'MissingCardBusinessTermsUrl');
  };

  const usesMigratedTermsKeys = MARKETS_WITH_MIGRATED_CARD_TERMS_KEYS.includes(
    market
  );

  return {
    openProductTerms,
    openPriceList,
    openGeneralTerms,
    usesMigratedTermsKeys,
  };
};

export default useCardLinks;
